import { transformSearch } from "@/api/helper.ts";
import { queryOptions } from "@tanstack/react-query";
import { z } from "zod";
import branchService from "../services/branch-service";

export const branchSearchSchema = z.object({
	search: z.string().optional(),
	page: z.number().nullable().optional(),
	per_page: z.number().optional(),
});

export const branchQueryOptions = (search?: z.infer<typeof branchSearchSchema>) => {
	return queryOptions({
		queryKey: ["branches", search],
		queryFn: () => branchService.list(transformSearch(search, ["search"])),
	});
};

// export const roleQueryOptions = (roleId: string) => {
// 	return queryOptions({
// 		queryKey: ["role", roleId],
// 		queryFn: () => roleService.findById(roleId),
// 	});
// };
